import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";
import { loginRequest, msalInstance } from "./authConfig";

export const useRedirectIfUnauthenticated = () => {
  const { accounts } = useMsal();


  useEffect(() => {
    const isOnline = navigator.onLine;
   const request = {
    ...loginRequest,
    account: msalInstance.getAllAccounts()?.[0],
  }; 
    if (isOnline && accounts.length === 0) {
      msalInstance.acquireTokenRedirect({
        ...request,
        prompt: "login",
      });
    }
  }, [accounts]);

  return { accounts };
};